import React from "react";
import Lottie from "react-lottie";
import * as LoaderAnimation from "./Loader.json";

interface PropsValues {
  width?: any;
  height?: any;
}
export default function Loader({ height = 300, width = 500 }: PropsValues) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LoaderAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions} height={height} width={width} />;
}
